(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // ---------------- Storage + Cache ----------------
  function ssGet(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function ssSet(key, val) {
    sessionStorage.setItem(key, JSON.stringify(val));
  }
  function cacheGet(key, ttlMs) {
    const obj = ssGet(key);
    if (!obj || !obj.t || typeof obj.v === 'undefined') return null;
    if (Date.now() - obj.t > ttlMs) return null;
    return obj.v;
  }
  function cacheSet(key, val) {
    ssSet(key, { t: Date.now(), v: val });
  }

  // ---------------- Helpers ----------------
  function money(n) {
    const num = Number(n);
    if (!isFinite(num)) return String(n || '');
    return num.toLocaleString('en-PK');
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function normalizeImgUrl(url) {
    url = (url || '').trim();
    if (!url) return '';
    if (url.startsWith('//')) return 'https:' + url;
    if (url.startsWith('/')) return window.location.origin + url;
    return url;
  }

  function cnicDigits(v) { return (v || '').replace(/\D+/g, '').slice(0, 13); }
  function phoneDigits(v) { return (v || '').replace(/\D+/g, '').slice(0, 11); }
  function isEmail(v) {
    v = (v || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function getQBProduct() {
    try { return JSON.parse(sessionStorage.getItem('qb_product') || 'null'); }
    catch (e) { return null; }
  }
  function setQBCheckoutDraft(d) {
    sessionStorage.setItem('qb_checkout_draft', JSON.stringify(d));
  }
  function getQBCheckoutDraft() {
    try { return JSON.parse(sessionStorage.getItem('qb_checkout_draft') || 'null'); }
    catch (e) { return null; }
  }

  // ---------------- API ----------------
  async function apiGet(path) {
    const r = await fetch('/apps/qistbazaar' + path, { credentials: 'same-origin' });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || j.ok === false) throw new Error((j && j.error) || 'API error');
    return j;
  }
  async function apiPost(path, body) {
    const r = await fetch('/apps/qistbazaar' + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || j.ok === false) throw new Error((j && j.error) || 'API error');
    return j;
  }

  function normalizeQBList(raw) {
    const data = raw && raw.data;
    if (Array.isArray(data)) return data;
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) { return []; }
    }
    return [];
  }

  // ---------------- EMI helpers ----------------
  function getMonth(p) {
    return Number(p?.noOfMonths ?? p?.month ?? p?.months ?? p?.tenure ?? 0);
  }
  function getMonthly(p) {
    return Number(p?.amountPerMonth ?? p?.monthlyInstallment ?? p?.installmentAmount ?? 0);
  }
  function getUpfront(p) {
    return Number(p?.advanceAmount ?? p?.advance ?? p?.upfrontPayment ?? 0);
  }

  function pick4Plans(plansAll) {
    if (!Array.isArray(plansAll) || plansAll.length === 0) return [];
    const preferred = [3, 6, 9, 12];
    const uniq = new Map();

    for (const m of preferred) {
      const p = plansAll.find(x => getMonth(x) === m);
      if (p) uniq.set(m, p);
    }
    for (const p of plansAll) {
      if (uniq.size >= 4) break;
      const m = getMonth(p);
      if (!m) continue;
      if (!uniq.has(m)) uniq.set(m, p);
    }
    return Array.from(uniq.values()).slice(0, 4);
  }

  // ---------------- CART PAGE ----------------
  async function renderCartPage() {
    const root = qs('#qb-cart-root');
    if (!root) return;

    const qb = getQBProduct();
    if (!qb || !qb.variantId) {
      root.innerHTML = `
        <div class="qb-card">
          <div class="qb-title">No product selected</div>
          <div class="qb-muted">Go back to product page and click “Buy with QistBazaar”.</div>
        </div>`;
      return;
    }

    const categoryID = Number(qb?.categoryID || 0);
if (!categoryID) {
  root.innerHTML = `
    <div class="qb-card">
      <div class="qb-title">Category mapping missing</div>
      <div class="qb-err">Please set Shopify metafield <strong>custom.qb_category_id</strong> for this product.</div>
    </div>
  `;
  return;
}

    root.innerHTML = `<div class="qb-card"><div class="qb-title">Loading...</div></div>`;

    const variantId = String(qb.variantId);
    const draft = getQBCheckoutDraft();
    const sameVariantDraft = !!(draft && String(draft.variantId) === variantId);

    // Variant
    const v = await apiGet('/variant?variantId=' + encodeURIComponent(variantId));
    const price = Number(v?.variant?.price || 0);
    const productCost = Math.round(price);

    // EMI cache (10 min)
    const emiCacheKey = 'qb_emi_' + String(productCost);
    let emi = cacheGet(emiCacheKey, 10 * 60 * 1000);
    if (!emi) {
      emi = await apiGet('/emi?productCost=' + encodeURIComponent(productCost));
      cacheSet(emiCacheKey, emi);
    }
    const plansAll = Array.isArray(emi?.plans) ? emi.plans : [];
    const plans = pick4Plans(plansAll);
    if (!plans.length) throw new Error('No EMI plans returned.');

    // Title/Image
    const productTitle = qb.productTitle || v.variant.title || '';
    const productImage = normalizeImgUrl(qb.productImage || '');

    // state
    let selectedMonth = 0;

    root.innerHTML = `
      <div class="qb-card qb-cart-head">
        <div class="qb-cart-head-left">
          <div class="qb-title-main">QistBazaar Cart</div>
          <div class="qb-line"><strong>Product:</strong> ${escapeHtml(productTitle)}</div>
          <div class="qb-line"><strong>Price:</strong> ${escapeHtml(v.variant.price || '')} PKR</div>
        </div>
        ${productImage ? `
          <div class="qb-cart-head-right">
            <img class="qb-cart-img" src="${escapeHtml(productImage)}" alt="${escapeHtml(productTitle)}">
          </div>` : ``}
      </div>

      <div class="qb-card">
        <div class="qb-title">Customer Information</div>

        <div class="qb-field">
          <label>Full Name</label>
          <input id="qb_name" type="text" autocomplete="name" placeholder="Enter full name" />
          <div class="qb-err" id="err_name"></div>
        </div>

        <div class="qb-field qb-hidden" id="qb_step_email">
          <label>Email</label>
          <input id="qb_email" type="email" autocomplete="email" placeholder="Enter email" />
          <div class="qb-err" id="err_email"></div>
        </div>

        <div class="qb-field qb-hidden" id="qb_step_phone">
          <label>Phone (digits only)</label>
          <input id="qb_phone" type="tel" inputmode="numeric" placeholder="03XXXXXXXXX" />
          <div class="qb-err" id="err_phone"></div>
        </div>

        <div class="qb-field qb-hidden" id="qb_step_address">
          <label>Address</label>
          <input id="qb_address" type="text" autocomplete="street-address" placeholder="House, street, etc." />
          <div class="qb-err" id="err_address"></div>
        </div>

        <div class="qb-grid">
          <div class="qb-field">
            <label>City</label>
            <select id="qb_city"><option value="">Loading cities...</option></select>
            <div class="qb-err" id="err_city"></div>
          </div>

          <div class="qb-field">
            <label>Area</label>
            <select id="qb_area"><option value="">Select city first</option></select>
            <div class="qb-err" id="err_area"></div>
          </div>

          <div class="qb-field qb-grid-full">
            <label>CNIC (13 digits)</label>
            <input id="qb_cnic" type="text" inputmode="numeric" placeholder="4210XXXXXXXXX" maxlength="13" />
            <div class="qb-err" id="err_cnic"></div>
          </div>
        </div>
      </div>

      <div class="qb-card">
        <div class="qb-title-select-emi">Select EMI Plan:</div>
        <div class="qb-plans-maindiv" id="qb_plans"></div>
        <div class="qb-err-plan" id="err_plan"></div>
      </div>

      <div class="qb-card">
        <button class="qb-btn primary" id="qb_to_checkout" disabled>Proceed to Checkout</button>
        <div class="qb-err" id="qb_submit_err"></div>
      </div>
    `;

    // elements
    const nameEl = qs('#qb_name');
    const emailEl = qs('#qb_email');
    const phoneEl = qs('#qb_phone');
    const addrEl = qs('#qb_address');
    const cnicEl = qs('#qb_cnic');
    const citySel = qs('#qb_city');
    const areaSel = qs('#qb_area');

    const emailWrap = qs('#qb_step_email');
    const phoneWrap = qs('#qb_step_phone');
    const addrWrap = qs('#qb_step_address');

    const btn = qs('#qb_to_checkout');

    function setErr(id, msg) {
      const el = qs('#' + id);
      if (el) el.textContent = msg || '';
    }

    function validateName(show = true) {
      const v = (nameEl.value || '').trim();
      const ok = v.length >= 2;
      if (show) setErr('err_name', ok ? '' : 'Name is required.');
      return ok;
    }
    function validateEmail(show = true) {
      const v = (emailEl.value || '').trim();
      const ok = isEmail(v);
      if (show) setErr('err_email', ok ? '' : 'Valid email is required.');
      return ok;
    }
    function validatePhone(show = true) {
      const v = phoneDigits(phoneEl.value);
      phoneEl.value = v;
      const ok = v.length >= 10;
      if (show) setErr('err_phone', ok ? '' : 'Valid phone is required.');
      return ok;
    }
    function validateAddress(show = true) {
      const v = (addrEl.value || '').trim();
      const ok = v.length >= 5;
      if (show) setErr('err_address', ok ? '' : 'Address is required.');
      return ok;
    }
    function validateCity(show = true) {
      const ok = !!citySel.value;
      if (show) setErr('err_city', ok ? '' : 'City is required.');
      return ok;
    }
    function validateArea(show = true) {
      const ok = !!areaSel.value;
      if (show) setErr('err_area', ok ? '' : 'Area is required.');
      return ok;
    }
    function validateCnic(show = true) {
      const v = cnicDigits(cnicEl.value);
      cnicEl.value = v;
      const ok = v.length === 13;
      if (show) setErr('err_cnic', ok ? '' : 'CNIC must be 13 digits.');
      return ok;
    }
    function validatePlan(show = true) {
      const ok = !!selectedMonth;
      if (show) setErr('err_plan', ok ? '' : 'Please select an EMI plan.');
      return ok;
    }

    function handleProgressiveReveal() {
      if (validateName(false)) emailWrap.classList.remove('qb-hidden');
      else emailWrap.classList.add('qb-hidden');

      if (validateName(false) && validateEmail(false)) phoneWrap.classList.remove('qb-hidden');
      else phoneWrap.classList.add('qb-hidden');

      if (validateName(false) && validateEmail(false) && validatePhone(false)) addrWrap.classList.remove('qb-hidden');
      else addrWrap.classList.add('qb-hidden');
    }

    function updateProceedState() {
      const ok =
        validateName(false) &&
        validateEmail(false) &&
        validatePhone(false) &&
        validateAddress(false) &&
        validateCity(false) &&
        validateArea(false) &&
        validateCnic(false) &&
        validatePlan(false);

      btn.disabled = !ok;
    }

    nameEl.addEventListener('input', () => { validateName(true); handleProgressiveReveal(); updateProceedState(); });
    emailEl.addEventListener('input', () => { validateEmail(true); handleProgressiveReveal(); updateProceedState(); });
    phoneEl.addEventListener('input', () => { validatePhone(true); handleProgressiveReveal(); updateProceedState(); });
    addrEl.addEventListener('input', () => { validateAddress(true); updateProceedState(); });
    cnicEl.addEventListener('input', () => { validateCnic(true); updateProceedState(); });

    // plans render
    const plansRoot = qs('#qb_plans');
    plansRoot.innerHTML = plans.map((p, idx) => {
      const m = getMonth(p);
      const monthly = getMonthly(p);
      const upfront = getUpfront(p);
      return `
        <div class="qb-plan" data-month="${m}" tabindex="0" role="button" aria-label="Select plan ${idx + 1}">
          <div class="qb-plan-title">Plan ${idx + 1}</div>
          <div class="qb-plan-line-money">Rs. ${money(monthly)} <span>x ${m} months</span></div>
          <div class="qb-plan-upfront">Rs. ${money(upfront)} <span class="qb-plan-upfront-span">Upfront Payment</span></div>
        </div>
      `;
    }).join('');

    function selectPlan(m) {
      selectedMonth = Number(m) || 0;
      qsa('.qb-plan', plansRoot).forEach(x => x.classList.remove('active'));
      const el = qs('.qb-plan[data-month="' + selectedMonth + '"]', plansRoot);
      if (el) el.classList.add('active');
      validatePlan(true);
      updateProceedState();
    }

    qsa('.qb-plan', plansRoot).forEach(el => {
      el.addEventListener('click', () => selectPlan(el.getAttribute('data-month')));
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPlan(el.getAttribute('data-month'));
        }
      });
    });

    // cities/areas cache (10 min)
    let citiesResp = cacheGet('qb_cities', 10 * 60 * 1000);
    let areasResp  = cacheGet('qb_areas',  10 * 60 * 1000);
    if (!citiesResp) { citiesResp = await apiGet('/cities'); cacheSet('qb_cities', citiesResp); }
    if (!areasResp)  { areasResp  = await apiGet('/areas');  cacheSet('qb_areas',  areasResp);  }

    const citiesData = normalizeQBList(citiesResp.raw);
    const areasData  = normalizeQBList(areasResp.raw);

    citySel.innerHTML =
      `<option value="">Select city</option>` +
      citiesData.map(c =>
        `<option value="${String(c.cityID)}" data-name="${escapeHtml(c.cityName)}">${escapeHtml(c.cityName)}</option>`
      ).join('');

    function fillAreas(cityID) {
      const filtered = areasData.filter(a => String(a.cityID) === String(cityID));
      areaSel.innerHTML =
        `<option value="">Select area</option>` +
        filtered.map(a =>
          `<option value="${String(a.areaID)}" data-name="${escapeHtml(a.areaName)}">${escapeHtml(a.areaName)}</option>`
        ).join('');
    }

    citySel.addEventListener('change', () => {
      fillAreas(citySel.value);
      validateCity(true);
      validateArea(true);
      updateProceedState();
    });

    areaSel.addEventListener('change', () => {
      validateArea(true);
      updateProceedState();
    });

    // Prefill from draft + restore selection
    if (sameVariantDraft) {
      nameEl.value  = draft.name || '';
      emailEl.value = draft.email || '';
      phoneEl.value = draft.phoneNo || '';
      addrEl.value  = draft.address || '';
      cnicEl.value  = draft.cnic || '';

      handleProgressiveReveal();

      // Restore city/area by NAME after options exist
      if (draft.city) {
        const cityOpt = Array.from(citySel.options).find(o =>
          (o.getAttribute('data-name') || '').toLowerCase() === String(draft.city).toLowerCase()
        );
        if (cityOpt) {
          citySel.value = cityOpt.value;
          fillAreas(citySel.value);

          if (draft.area) {
            const areaOpt = Array.from(areaSel.options).find(o =>
              (o.getAttribute('data-name') || '').toLowerCase() === String(draft.area).toLowerCase()
            );
            if (areaOpt) areaSel.value = areaOpt.value;
          }
        }
      }

      // Restore selected plan
      if (draft.month && plans.some(p => getMonth(p) === Number(draft.month))) {
        selectPlan(Number(draft.month));
      }
    }

    // proceed
    btn.addEventListener('click', () => {
      qs('#qb_submit_err').textContent = '';

      const ok =
        validateName(true) &&
        validateEmail(true) &&
        validatePhone(true) &&
        validateAddress(true) &&
        validateCity(true) &&
        validateArea(true) &&
        validateCnic(true) &&
        validatePlan(true);

      if (!ok) {
        qs('#qb_submit_err').textContent = 'Please complete all required fields and select an EMI plan.';
        updateProceedState();
        return;
      }

      const name = (nameEl.value || '').trim();
      const email = (emailEl.value || '').trim();
      const phoneNo = phoneDigits(phoneEl.value);
      const address = (addrEl.value || '').trim();
      const cnic = cnicDigits(cnicEl.value);

      const cityName = citySel.options[citySel.selectedIndex]?.getAttribute('data-name') || '';
      const areaName = areaSel.options[areaSel.selectedIndex]?.getAttribute('data-name') || '';
      const areaID = Number(areaSel.value);

      setQBCheckoutDraft({
        variantId,
        month: Number(selectedMonth),
        categoryID,
        name, email, phoneNo, address,
        city: cityName,
        area: areaName,
        areaID,
        cnic,
        productTitle,
        productImage
      });

      window.location.href = '/pages/qistbazaar-checkout';
    });

    // initial state
    handleProgressiveReveal();
    updateProceedState();
  }

  // ---------------- CHECKOUT PAGE ----------------
  async function renderCheckoutPage() {
    const root = qs('#qb-checkout-root');
    if (!root) return;

    const d = getQBCheckoutDraft();
    if (!d || !d.variantId) {
      root.innerHTML = `
        <div class="qb-card">
          <div class="qb-title">Checkout draft missing</div>
          <div class="qb-muted">Please start again from product page.</div>
        </div>`;
      return;
    }

    root.innerHTML = `<div class="qb-card"><div class="qb-title">Loading...</div></div>`;

    const v = await apiGet('/variant?variantId=' + encodeURIComponent(d.variantId));

    const priceNum = Number(v?.variant?.price || 0);
    const productCost = Math.round(priceNum);

    // EMI cache (10 min)
    const emiCacheKey = 'qb_emi_' + String(productCost);
    let emi = cacheGet(emiCacheKey, 10 * 60 * 1000);
    if (!emi) {
      emi = await apiGet('/emi?productCost=' + encodeURIComponent(productCost));
      cacheSet(emiCacheKey, emi);
    }

    const plansAll = Array.isArray(emi?.plans) ? emi.plans : [];
    const plan =
      plansAll.find(x => getMonth(x) === Number(d.month)) ||
      plansAll[0] ||
      null;

    const productTitle = d.productTitle || v?.variant?.title || '';
    const productImage = normalizeImgUrl(d.productImage || '');
    const cityArea = [d.area, d.city].filter(Boolean).join(', ');

    const upfront = plan ? getUpfront(plan) : 0;
    const monthly = plan ? getMonthly(plan) : 0;
    const total   = plan ? Number(plan.totalPrice ?? plan.totalAmount ?? plan.total ?? 0) : 0;
    const months  = plan ? getMonth(plan) : Number(d.month || 0);

    root.innerHTML = `
      <div class="qb-checkout-wrap">
        <div class="qb-checkout-card">
          <div class="qb-checkout-title">QistBazaar Checkout</div>

          <div class="qb-checkout-subtitle">Product Details</div>

          <div class="qb-checkout-product">
            <div class="qb-checkout-product-left">
              <div class="qb-checkout-prod-name">${escapeHtml(productTitle)}</div>
              <div class="qb-checkout-prod-line"><span>Price:</span> ${escapeHtml(v?.variant?.price || '')} PKR</div>
            </div>

            <div class="qb-checkout-product-right">
              ${productImage ? `<img class="qb-checkout-img" src="${escapeHtml(productImage)}" alt="${escapeHtml(productTitle)}">` : ``}
            </div>
          </div>

          <div class="qb-checkout-subtitle qb-mt12">EMI Breakdown</div>
          <div class="qb-checkout-breakdown">
            <div class="qb-break-row"><span>Total Price:</span> <strong>${money(total)} PKR</strong></div>
            <div class="qb-break-row"><span>Upfront Payment (Advance):</span> <strong>${money(upfront)} PKR</strong></div>
            <div class="qb-break-row"><span>Monthly Installment:</span> <strong>${money(monthly)} PKR</strong></div>
            <div class="qb-break-row"><span>Installment Duration:</span> <strong>${escapeHtml(months)} months</strong></div>
          </div>

          <div class="qb-checkout-subtitle qb-mt12">Customer Details</div>
          <div class="qb-checkout-customer">
            <div class="qb-cust-row"><span>Name:</span> <strong>${escapeHtml(d.name || '')}</strong></div>
            <div class="qb-cust-row"><span>Email:</span> <strong>${escapeHtml(d.email || '')}</strong></div>
            <div class="qb-cust-row"><span>Phone:</span> <strong>${escapeHtml(d.phoneNo || '')}</strong></div>
            <div class="qb-cust-row"><span>CNIC:</span> <strong>${escapeHtml(d.cnic || '')}</strong></div>
            <div class="qb-cust-row"><span>Address:</span> <strong>${escapeHtml([d.address, cityArea].filter(Boolean).join(', '))}</strong></div>
          </div>

          <div class="qb-checkout-actions qb-mt16">
            <button type="button" class="qb-btn secondary" id="qb_edit_customer">Edit Customer Info</button>
            <button type="button" class="qb-btn primary" id="qb_confirm">Confirm Order</button>
          </div>

          <div class="qb-err qb-mt8" id="qb_confirm_err"></div>
        </div>
      </div>
    `;

    // Edit -> back to cart (draft stays)
    qs('#qb_edit_customer')?.addEventListener('click', () => {
      window.location.href = '/pages/qistbazaar-cart?edit=1';
    });

    // Confirm
    const btn = qs('#qb_confirm');
    btn?.addEventListener('click', async () => {
      qs('#qb_confirm_err').textContent = '';
      btn.disabled = true;
      const oldText = btn.textContent;
      btn.textContent = 'Submitting...';

      try {
        const res = await apiPost('/order/create', d);
        const qbOrderId = res.qbOrderID || (res.qb && res.qb.orderID) || '';
        const shopOrder = res.shopifyOrderName || '';

        window.location.href =
          '/pages/qistbazaar-thankyou?qbOrderID=' +
          encodeURIComponent(qbOrderId) +
          '&shopifyOrder=' +
          encodeURIComponent(shopOrder);
          sessionStorage.setItem('qb_last_order', JSON.stringify({
  qbOrderID: qbOrderId,
  shopifyOrder: shopOrder,
  draft: d,
  plan: {
    total,
    upfront,
    monthly,
    months
  },
  basePrice: v?.variant?.price || ''
}));
      } catch (e) {
        qs('#qb_confirm_err').textContent = e.message || 'Failed.';
      } finally {
        btn.disabled = false;
        btn.textContent = oldText;
      }
    });
  }

  // ---------------- THANKYOU PAGE ----------------
  function renderThankyou() {
  const root = document.querySelector('#qb-thankyou-root');
  if (!root) return;

  let last = null;
  try { last = JSON.parse(sessionStorage.getItem('qb_last_order') || 'null'); } catch(e){}

  const p = new URLSearchParams(window.location.search);
  const qbOrderID = (last && last.qbOrderID) || p.get('qbOrderID') || '';
  const shopifyOrder = (last && last.shopifyOrder) || p.get('shopifyOrder') || '';

  const d = last?.draft || {};
  const plan = last?.plan || {};
  const productTitle = d.productTitle || '';
  const basePrice = last?.basePrice || '';
  const addressLine = [d.address, d.area, d.city].filter(Boolean).join(', ');

  root.innerHTML = `
    <div class="qb-thanks-wrap">
      <div class="qb-thanks-card">

        <div class="qb-thanks-header">
          <div class="qb-thanks-check">✓</div>
          <div class="qb-thanks-title">Thank You for Your Order!</div>
          <div class="qb-thanks-sub">Your Order ID is: <strong>${escapeHtml(qbOrderID)}</strong></div>
          <div class="qb-thanks-sub2">A Customer Service Representative will contact you shortly.</div>
        </div>

        <div class="qb-thanks-section">
          <div class="qb-thanks-h">Order Summary</div>
          <div class="qb-thanks-row"><span>Product:</span> <strong>${escapeHtml(productTitle)}</strong></div>
          <div class="qb-thanks-row"><span>Price:</span> <strong>${escapeHtml(basePrice)} PKR</strong></div>
          <div class="qb-thanks-row"><span>Customer Name:</span> <strong>${escapeHtml(d.name || '')}</strong></div>
          <div class="qb-thanks-row"><span>Email:</span> <strong>${escapeHtml(d.email || '')}</strong></div>
          <div class="qb-thanks-row"><span>Phone:</span> <strong>${escapeHtml(d.phoneNo || '')}</strong></div>
          <div class="qb-thanks-row"><span>Address:</span> <strong>${escapeHtml(addressLine)}</strong></div>
          <div class="qb-thanks-row"><span>CNIC:</span> <strong>${escapeHtml(d.cnic || '')}</strong></div>
        </div>

        <div class="qb-thanks-section">
          <div class="qb-thanks-h">Payment Details</div>
          <div class="qb-thanks-row"><span>Total Price:</span> <strong>${money(plan.total)} PKR</strong></div>
          <div class="qb-thanks-row"><span>Upfront Payment (Advance):</span> <strong>${money(plan.upfront)} PKR</strong></div>
          <div class="qb-thanks-row"><span>Monthly Installment:</span> <strong>${money(plan.monthly)} PKR</strong></div>
          <div class="qb-thanks-row"><span>Installment Duration:</span> <strong>${escapeHtml(plan.months)} months</strong></div>
        </div>

        <div class="qb-thanks-section">
          <div class="qb-thanks-h">Next Steps</div>
          <ul class="qb-thanks-list">
            <li>Pay the upfront (advance) amount as shown above.</li>
            <li>Your monthly installments will be deducted as per the EMI schedule.</li>
            <li>If you need to make changes or have questions, please contact our support team.</li>
          </ul>
        </div>

        <div class="qb-thanks-section">
          <div class="qb-thanks-h">Payment Options</div>
          <div class="qb-thanks-note">You can complete your payment using JazzCash or EasyPaisa.</div>
        </div>

        <div class="qb-thanks-actions">
          <a class="qb-thanks-btn" href="/collections/all">Continue Shopping</a>
        </div>

        ${shopifyOrder ? `<div class="qb-thanks-foot">Shopify Order: <strong>${escapeHtml(shopifyOrder)}</strong></div>` : ``}
      </div>
    </div>
  `;
}

  document.addEventListener('DOMContentLoaded', () => {
    const page = (window.QB_APP && window.QB_APP.page) ? window.QB_APP.page : '';
    if (page === 'cart') {
      renderCartPage().catch(e => {
        const root = qs('#qb-cart-root');
        if (root) root.innerHTML = `<div class="qb-card"><div class="qb-title">Error</div><div class="qb-err">${escapeHtml(e.message || '')}</div></div>`;
      });
    }
    if (page === 'checkout') {
      renderCheckoutPage().catch(e => {
        const root = qs('#qb-checkout-root');
        if (root) root.innerHTML = `<div class="qb-card"><div class="qb-title">Error</div><div class="qb-err">${escapeHtml(e.message || '')}</div></div>`;
      });
    }
    if (page === 'thankyou') renderThankyou();
  });
})();

